import { render, staticRenderFns } from "./HowItWorksPopup.vue?vue&type=template&id=3db8b350"
import script from "./HowItWorksPopup.vue?vue&type=script&lang=js"
export * from "./HowItWorksPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports